// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2NDJp","text":"SelectPayment_text__2rmn2","title":"SelectPayment_title__3sUYz","btn":"SelectPayment_btn__1JjTi"};